import React, { useState } from 'react';
import axios from 'axios';
import './LoginIslam.css'; // Assuming you will create this file for styling
import { useNavigate } from 'react-router-dom';
import SidebarComponent from '../SidebarComponent';
import Bubbles from '../Bubbles';

const Login = () => {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [response, setResponse] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/login`, {
        phone,
        password,
      });
      const { data } = res;
      setResponse(data);

      // Save token and educational_level_id to local storage
      localStorage.setItem('authToken', data.token);
      localStorage.setItem('educationalLevelId', data.user.educational_level_id);
      localStorage.setItem('id', data.user.id);

      // Navigate to /Mr.Monem2 if user ID is 60, otherwise go to /PricingCard
     
        navigate('/CardIslam');

      console.log('Login Success:', data);
    } catch (error) {
      setError('Login Failed: ' + 'برجاء التاكد من الايميل او كلمه السر 🚫');
      console.error('Login Failed:', error.response ? error.response.data : error.message);
    }
  };

  const BachHome = async (e) => {
    navigate('/Mr.IslamAbdElazeem');
  };

  return (
  <div className="login-page12s">
      {/* <Bubbles /> */}
      <div className="login-card animiL">
        <h2 className="login-title">Log In</h2>
        <p className="login-subtitle">
          Don’t have an Account? <a href="/SignupIslam">Create Account</a>
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Mobile Number</label>
            <input
              type="text"
              placeholder="010000000"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              placeholder="Enter password here"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button type="submit" className="btn-login">Log In</button>
          <button type="button" className="btn-home" onClick={BachHome}>الرئيسيه</button>
        </form>

        {response && <div className="response success">Login Successful 🎉</div>}
        {error && <div className="response error">{error}</div>}
      </div>
    </div>
  );
};

export default Login;
